import React, {useState, useEffect,Suspense, lazy} from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Crypto_prices from './pages/Crypto_prices';
import { registerToastSetter } from './API/AxiosInstance';
import { authEvents$ } from './API/AxiosInstance';
import { setAuth0Client } from './API/auth0Client';
import { useAuth0 } from '@auth0/auth0-react';
import CommonLoader from './components/CommonLoader';
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Overview = lazy(() => import("./pages/Overview"));
const News = lazy(() => import("./pages/News"));
const Portfolio = lazy(() => import("./pages/Portfolio"));
const Sumsubkyc = lazy(() => import("./pages/Sumsubkyc"));
const Settings = lazy(() => import("./pages/Settings/Settings"));
const Transactions = lazy(() => import("./pages/Transactions/Transactions"));
const Messages = lazy(() => import("./pages/Messages"));
const Products = lazy(() => import("./pages/Products"));
const ProductDetails = lazy(() => import("./pages/Products/ProductDetails"));
const Questionaire = lazy(() => import("./pages/Questionaire/Questionaire"));
const SuccessSubscribed = lazy(() => import("./pages/Products/SuccessSubscribed"));
const EditProfile = lazy(() => import("./components/UserAccount/EditProfile"));
const DocusignReponse = lazy(() => import("./pages/Settings/DocuSignResponse"));
const Signup = lazy(() => import("./pages/Signup"));
const ToastAlert = lazy(() => import("./utils/Toaster"));
const ErrorModal = lazy(() => import("./utils/Error401Modal"));
const MainDashboardEntry = lazy(() => import("./pages/MainDashboardEntry "));
const NotificationList = lazy(() => import("./pages/Notifications/NotificationList"));
const NotificationDetails = lazy(() => import("./pages/Notifications/NotificationDetails"));



function App() {
  const [toastStatus,setToastStatus] = useState({color:'',status:false,message:'',icon:''})
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const auth0 = useAuth0();
  setAuth0Client(auth0);

  // console.log = function() {}
  // console.warn = function() {}
  // console.error = function() {}
  // Register Firebase Service Worker
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered:", registration);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

useEffect(() => {
  registerToastSetter(setToastStatus);
}, []);

useEffect(() => {
    const unsubscribe = authEvents$.subscribe(async (event) => {
      if (event.type === '401') {
        console.log("App.js caught 401 via observable");
          setErrorModalOpen(true)
      }
    });

    return () => unsubscribe(); 
  }, []);


  const handleRetry = () => {
    window.location.reload()
  }


const withSuspense = (Component) => (
  <Suspense fallback={<CommonLoader />}>
    <Component />
  </Suspense>
);


  return (
    <>
    {/* <ToastContainer toasts={toasts} onRemove={(id) => setToasts((p) => p.filter((t) => t.id !== id))} /> */}
    <ErrorModal  open={errorModalOpen} onRetry={handleRetry} />
    <ToastAlert  message={toastStatus?.message} status={toastStatus?.status}  color={toastStatus?.color} icon={toastStatus?.icon} closeFunc={() => setToastStatus({color:'',status:false})} />  
      <BrowserRouter>
      <Suspense fallback={<CommonLoader />}>
        <Routes>
          <Route path="/Questionnaire" element={withSuspense(Questionaire)} />
          <Route path="/Signup" element={withSuspense(Signup)} />
          <Route path="/" element={withSuspense(MainDashboardEntry)}>
          <Route index element={withSuspense(Overview)} />
          <Route path="Cryptoprices" element={withSuspense(Crypto_prices)} />
          <Route path="News" element={withSuspense(News)} />
          <Route path="Portfolio" element={withSuspense(Portfolio)} />
          <Route path="Sumsubkyc" element={withSuspense(Sumsubkyc)} />
          <Route path="Settings" element={withSuspense(Settings)} />
          <Route path="Transactions" element={withSuspense(Transactions)} />
          <Route path="Messages" element={withSuspense(Messages)} />
          <Route path="Products" element={withSuspense(Products)} />
          <Route path="Products/ProductDetails/:id" element={withSuspense(ProductDetails)} />
          <Route path="SuccessSubscribed" element={withSuspense(SuccessSubscribed)} />
          <Route path="editProfile" element={withSuspense(EditProfile)} />
          <Route path="docusignResponse" element={withSuspense(DocusignReponse)} />
          <Route path="notification" element={withSuspense(NotificationList)} />
          <Route path="/notificationDetail/:id" element={withSuspense(NotificationDetails)} />
        </Route>
        </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

// export default Sentry.withProfiler(App)
export default App